import { render, staticRenderFns } from "./manageNotifier.vue?vue&type=template&id=59d3d267"
import script from "./manageNotifier.vue?vue&type=script&lang=js"
export * from "./manageNotifier.vue?vue&type=script&lang=js"
import style0 from "./manageNotifier.vue?vue&type=style&index=0&id=59d3d267&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports